import React from 'react'; 
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";

import WithConsumer from '../context/WithConsumer';

const CollectionThumbs = ({context}) => {
	
    const posts = () => context.posts;
    const item = posts()[0];
    
    const activeFiltersCtx = () => context.filters;
    const activeFilters = activeFiltersCtx();
    
    let foundThumbs = 0;
    
	
	function GetDesigner(thumb) {
		if (thumb.designer_name) {
			return <h5 className="c-thumb__designer" dangerouslySetInnerHTML={ {__html: thumb.designer_name } }></h5>
   		} else {
   			return <h5 className="c-thumb__designer">Bloomingdales</h5>	
		}
  	}
  	
  	function GetThumb(thumb, instock, key) {
	  	
	  	let designerFound = false;
	  	let productCatFound = false;
	  	let finishFound = false;
	  	
	  	let i = 0;
	  	if (activeFilters.designer.length > 0 && thumb.filter.length > 0) {
		  	for (i=0;i<thumb.filter.length;i++) {
			  	if (activeFilters.designer.includes(parseInt(thumb.filter[i]))) {
				  	designerFound = true;
			  	}
		  	}
	  	} else {
		  	designerFound = true;
	  	}
	  	
	  	if (activeFilters.product_cat.length > 0 && thumb.filter.length > 0) {
		  	for (i=0;i<thumb.filter.length;i++) {
			  	if (activeFilters.product_cat.includes(parseInt(thumb.filter[i]))) {
				  	productCatFound = true;
			  	}
		  	}
	  	} else {
		  	productCatFound = true;
	  	}
	  	
	  	if (activeFilters.finish.length > 0 && thumb.filter.length > 0) {
		  	for (i=0;i<thumb.filter.length;i++) {
			  	if (activeFilters.finish.includes(thumb.filter[i])) {
				  	finishFound = true;
			  	}
		  	}
	  	} else {
		  	finishFound = true;
	  	}	
	  	
	  	let instockFound = true;
	  	if (instock === true && thumb.instock === false) {
		  	instockFound = false;
	  	}  	
	  	if (designerFound === true && productCatFound === true && finishFound === true && instockFound === true) {
		  	foundThumbs = foundThumbs + 1;
		  	return (
			  	<div className="l-grid__col l-grid__col--s-3-6 l-grid__col--m-6-12 l-grid__col--l-4-12 l-grid__col--xxl-3-12" key={key}>
		   			<Link to={{ pathname: '/product/' + thumb.slug}} className="c-thumb" onClick={context.updateScrollPos}>
		   				<div className="c-thumb__inner">
		   					<FadeIn duration={250}>
								{onload => (
									<img
										alt={thumb.title} 
										src={thumb.src} 
										srcSet={thumb.srcset} 
										onLoad={onload}
									/>
								)}
							</FadeIn>
							{thumb.sales_message &&
								<p className="c-thumb__sales-message" dangerouslySetInnerHTML={{__html: thumb.sales_message }} style={{backgroundColor:thumb.sale_message_background_colour,color:thumb.sale_message_text_colour}}></p>
							}
		   				</div>
		   				<h4 className="c-thumb__title" dangerouslySetInnerHTML={ {__html: thumb.title } }></h4>
		   				{ GetDesigner(thumb) }
		   				
		   			</Link>
		   		</div>
	   		)
	  	} else {
		  	return (<div key={key}></div>);
	  	}
  	}
  	
  	if (item.thumbs) {
	  	const thumbs = item.thumbs.map((thumb,i) =>
	   		GetThumb(thumb, item.in_stock, i)
	   	);
	   	
		return (
			<div className="c-thumbs">
				<div className="l-grid">
					{ thumbs }
					{foundThumbs === 0 &&
						<div className="l-grid__col">
							<div className="c-empty">
								<h3 className="c-empty__heading">No products were found</h3>
								<p className="c-empty__subheading">No products matched the filters you selected. Please try adjusting the filters selected.</p>
							</div>
						</div>
					}
				</div>
			</div>
		);
	} else {
		return null;
	}
};
export default WithConsumer(CollectionThumbs);